const contentWrapperCls = "_275c1b6ap65";

export { contentWrapperCls };
import "./_page.style.linaria.module.css";
//# sourceMappingURL=_page.style.js.map
